import { isNumber } from 'lodash-es'
interface BrowserInter {
  browser: string;
  version: string;
}

// 检测设备类型(手机返回true,反之)
export const deviceDetection = () => {
  const sUserAgent = navigator.userAgent.toLowerCase();
  // const bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
  const bIsIphoneOs = sUserAgent.match(/iphone os/i)?.toString() == "iphone os";
  const bIsMidp = sUserAgent.match(/midp/i)?.toString() == "midp";
  const bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i)?.toString() == "rv:1.2.3.4";
  const bIsUc = sUserAgent.match(/ucweb/i)?.toString() == "ucweb";
  const bIsAndroid = sUserAgent.match(/android/i)?.toString() == "android";
  const bIsCE = sUserAgent.match(/windows ce/i)?.toString() == "windows ce";
  const bIsWM = sUserAgent.match(/windows mobile/i)?.toString() == "windows mobile";
  
	return (
    bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM
  );
};


export const isWxWork = ()=> navigator.userAgent.toLowerCase().match(/wxwork/i) !== null

// 微信小程序
export const isMiniProgram = () =>
  navigator.userAgent.toLowerCase().match(/miniprogram/i) !== null

// 获取浏览器型号以及版本
export const getBrowserInfo = () => {
  const ua = navigator.userAgent.toLowerCase();
  const re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/;
  const m = ua.match(re);
  const Sys: BrowserInter = {
    browser: m?.[1].replace(/version/, "'safari") || '',
    version: m?.[2] || ''
  };

  return Sys;
};

/**
 * 判断是触摸板还是鼠标滚轮
 * @param e wheel event
 */
export const isTouchpad = (e: any) => {
  let result = false; // 默认为鼠标滚轮滚动事件

  if (!e || !e.type || !isNumber(e.wheelDeltaY) || !isNumber(e.deltaY)) {
    return result;
  }

  if (
    e.deltaY === Math.ceil(e.wheelDeltaY / -3) ||
    e.deltaY === Math.floor(e.wheelDeltaY / -3)
  ) {
    result = true;
  }

  return result;
};
